import { getUserInfoApi, getContinuousInfo  } from '@/api/user'
import {
  saveToken,
  saveLoginStatus,
  saveUserInfo,
  removeToken,
  removeUserInfo,
  loadLoginStatus,
  savePermissionInfo,
  loadPermissionInfo,
  savePermissionVipInfo,
  loadPermissionVipInfo,
  loadToken,
  loadUserInfo
} from '@/utils/cache'

export default {
  namespaced: true,
  state: () => ({
    loginStatus: loadLoginStatus(), // 登录状态
    token: loadToken(), // token
    userInfo: loadUserInfo(), // 用户登录信息
    permissionInfo: loadPermissionInfo(), // 用户权限
    permissionVipInfo: loadPermissionVipInfo(), // 子会员类型
    /** 用户续费信息 */
    continuousInfo: {
      /** 签约状态。1 - 未签约； 2 - 已签约，正在生效 */
      continuous_status: 1,
      /** 套餐名称 */
      name: undefined,
      /** 下次续费时间, 格式为：yyyy-mm-dd HH:MM:SS */
      next_deduction_time: undefined,
      /** 套餐价格，单位为分 */
      price: undefined
    } 
  }),
  actions: {
    /**
     * 设置登录状态
     * @param {*} param0
     * @param {*} status 1:登录 0:普通退出，2:TOKEN过期退出
     */
    setLoginStatus ({ commit }, status) {
      const query = [0, 2].includes(status) ? 0 : 1
      if (query === 0) {
        removeToken()
        removeUserInfo()
        commit('SET_USERINFO', undefined)
      }
      commit('SET_LOGIN_STATUS', saveLoginStatus(query))
    },

    // 刷新用户
    /* eslint-disable-next-line */
    refresh ({ commit, state, dispatch  }, query) {
      if (query.token != state.token || query.webRefresh) {
        return new Promise((resolve, reject) => {
          getUserInfoApi({
            common: {
              token: query.token,
              open_id: query.open_id
            },
            return_permission: 1,
            return_permission_vip: 1
          })
            .then(res => {
              const data = res.data
              const resCom = res.resp_common

              if (resCom.ret == 0 && data && data.user_info) {
                dispatch('refreshContinuousInfo')
                saveUserInfo(data.user_info)
                saveToken(query.token)
                commit('SET_USERINFO', data.user_info)
                commit('SET_TOKEN', query.token)
                commit('SET_LOGIN_STATUS', saveLoginStatus(1))
              }
              if (resCom.ret == 0 && data && data.permission_info) {
                commit('SET_PERMISSIONINFO', savePermissionInfo(data.permission_info))
              }
              // 购买权益包的子会员类型
              if (resCom.ret == 0 && data && data.permission_vip_info) {
                commit('SET_PERMISSION_VIP_INFO', savePermissionVipInfo(data.permission_vip_info))
              }
              window.app.$EventBus.$emit('user_refresh')

              resolve(res)
            })
            .catch(error => {
              console.error(error)
              reject(error)
            })
        })
      }
    },
    /**
     * 刷新用户续费信息
     */
    refreshContinuousInfo ({ commit }) {
      try {
        getContinuousInfo().then(res => {
          commit('SET_CONTINUOUS_INFO', res)
        })
      } catch (error) {
        console.log('获取用户续费信息失败')
      }
    }

  },
  mutations: {
    SET_USERINFO (state, userInfo) {
      state.userInfo = userInfo
    },
    SET_PERMISSIONINFO (state, permission) {
      state.permissionInfo = permission
    },
    SET_LOGIN_STATUS (state, loginStatus) {
      state.loginStatus = loginStatus
    },
    SET_TOKEN (state, token) {
      state.token = token
    },
    SET_PERMISSION_VIP_INFO (state, permissionVipInfo) {
      state.permissionVipInfo = permissionVipInfo
    },
    SET_CONTINUOUS_INFO (state, continuousInfo) {
      state.continuousInfo = continuousInfo
    }
  }
}
